import {
  GeneralDispatchType,
  SET_LANGUAGE,
  SET_THEME,
} from "../../actions/general/GeneralActionType";

export interface IDefaultState {
  theme: string;
  language: string;
  beforeInstallEvent?: Event;
}

const defaultState: IDefaultState = {
  theme: "dark",
  language: "fa",
};

const GeneralReducer = (
  // eslint-disable-next-line no-restricted-globals
  state: IDefaultState = defaultState,
  action: GeneralDispatchType
): IDefaultState => {
  switch (action.type) {
    case SET_THEME:
      return {
        ...state,
        theme: action.payload.theme,
      };
    case SET_LANGUAGE:
      return {
        ...state,
        language: action.payload.language,
      };
    case "SET_BEFORE_INSTALL_EVENT":
      return {
        ...state,
        beforeInstallEvent: action.payload.beforeInstallEvent,
      };
    default:
      return state;
  }
};

export default GeneralReducer;
